import { UserDto } from '@/features/users/users.dto';

export interface CompanyDto {
	id: number;
	name: string;
	address: string;
	email: string;
	contactName: string;
	active: boolean;
	defaultTimeZoneId: number;
	geocodingMethod: number;
	geocodingFormat: number;
}

export interface CompanyResponseDto {
	id: number;
	name: string;
}

export enum ClientUsersByCompanyFilterType {
	ALL_CLIENT_USERS = 'ALL_CLIENT_USERS',
	CLIENT_ADMIN_USERS = 'CLIENT_ADMIN_USERS',
	CLIENT_USERS_BY_ROLE = 'CLIENT_USERS_BY_ROLE',
}

export type ClientsUsersByCompanyParams = {
	id: number;
	clientId: number;
	search?: string;
	filterType: ClientUsersByCompanyFilterType;
};

export type ProviderCompanyDto = {
	id: number;
	name: string;
	address: string;
	email: string;
	contactName: string;
	active: boolean;
	defaultTimeZoneId: number;
	geocodingMethod: number;
	geocodingFormat: number;
	createdAt: string;
	updatedAt: string;
	user: UserDto;
};

export type CompanyUserDataDto = {
	email: string;
	username: string;
	password: string;
	confirm: string;
	active: boolean;
};
export type CreateCompanyWithUserDto = {
	name: string;

	address: string;

	email: string;

	contactName: string;

	active: boolean;

	defaultTimeZoneId: number;

	geocodingMethod: number;

	geocodingFormat: number;

	user: CompanyUserDataDto;

	username?: string;

	password?: string;
};

export type DeleteCompaniesResponseDto = {
	deletedCount: number;
	skippedIds: number[];
};

export type CompanyCountriesDto = {
	companyId: number;
	countriesId: number;
};

export type UpdateCompanyWithUserDto = {
	id: number;
	name: string;
	email: string;
	active: boolean;
	username: string;
	cellphone: string;
	canceledAt: Date;
	languageId: number;
};

export type CompanyWithUserDto = {
	id: number;
	name: string;
	address: string;
	email: string;
	contactName: string;
	active: boolean;
	defaultTimeZoneId: number;
	geocodingMethod: number;
	geocodingFormat: number;
	user: UserDto;
};

export type CrossPlatformCustomerDto = {
	id: number;
	stripeCustomerId?: string;
	name: string;
	email?: string;
	phone?: string;
};

export type CrossPlatformMatchDto = {
	searchTerm: string;
	customer: CrossPlatformCustomerDto;
	otherMatchesCount: number;
};

export type CrossPlatformMatchResultDto = {
	rastreoSearchFailed: boolean;
	crossPlatformMatch: CrossPlatformMatchDto | null;
};

export type CrossPlatformSearchResponseDto = {
	crossPlatformMatchResult: CrossPlatformMatchResultDto;
};
